import IssueNoteDeletionPolicy from '../../../../../../packages/common/domain/issues/IssueNoteDeletionPolicy';

export const buildIssueNoteActions = ({ isIssueClosed, message, currentUser, onDeleteNote }) => {
   if (!onDeleteNote || !message || message.pending || message.failed) return [];

   const actorId = currentUser && (currentUser.noUser || currentUser._id || currentUser.id);
   const allowed = IssueNoteDeletionPolicy.canDeleteAtActionTime({
      isIssueClosed,
      frame: message,
      actorId
   });

   return allowed ? [{ label: 'Delete note', onClick: onDeleteNote }] : [];
};
